type RadioGroupProps = {
  name: string
  options: string[]
  value: string
  onChange: (value: string) => void
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  options,
  value,
  onChange,
}) => {
  return (
    <div className='flex gap-4'>
      {options.map((option) => {
        const isSelected = value === option

        return (
          <div
            key={option}
            onClick={() => onChange(isSelected ? '' : option)}
            className='flex justify-start items-center gap-2 cursor-pointer relative select-none'
          >
            <div
              className='relative w-4 h-4 bg-violet-100 rounded-full transition-all duration-150
                    shadow-[inset_-0.5px_1px_4px_0px_rgba(0,0,0,0.48),inset_0px_0.5px_0.5px_0px_rgba(255,255,255,0.12),inset_0px_-0.5px_0.5px_0px_rgba(255,255,255,0.08),inset_0.5px_-0.5px_2px_0px_rgba(255,255,255,0.08)]'
            >
              {isSelected && (
                <div className='absolute top-1/2 left-1/2 w-2 h-2 bg-[#B8E0DB] rounded-full transform -translate-x-1/2 -translate-y-1/2' />
              )}
            </div>

            <div className="text-center justify-center text-black text-base font-medium font-['DM_Sans'] leading-normal tracking-wide">
              {option}
            </div>
          </div>
        )
      })}
    </div>
  )
}
